import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs-plugin-utc';
import NumberFormat from 'react-number-format';
import currencySymbol from '../../../../../helpers/currencySymbol';
import MarkdownToHtml from '../../../../MarkdownToHtml';

dayjs.extend(dayjsPluginUTC);

const OverviewDetails = ({ hotelDetails, customOverViewContent }) => {
  const isValidDate = (date) => date && dayjs(date).isValid() && date !== '0001-01-01T00:00:00';

  return (
    <>
      <div className="grid grid-cols-6 gap-2 border-b-2  pb-2">
        <div className="col-span-4 md:col-span-5">
          <div className="font-bold">
            {hotelDetails.name}
          </div>
          <div className="mb-10">
            <div className="text-gray-500">
              <NumberFormat
                value={hotelDetails.starRating}
                displayType="text"
              />
              -star hotel •
              {` ${hotelDetails.city}, ${hotelDetails.address}`}
            </div>
            {customOverViewContent && <MarkdownToHtml content={customOverViewContent} className="text-black" />}
          </div>
        </div>
        <div className="col-span-2 lg:col-span-1 text-sm ld:text-base flex flex-col items-end ">
          {hotelDetails.price.totalAfterDiscount > 0
            && (
              <NumberFormat
                value={hotelDetails.price.totalAfterDiscount}
                displayType="text"
                thousandSeparator
                fixedDecimalScale="true"
                decimalScale="2"
                prefix={currencySymbol(hotelDetails.price.currencyCode)}
                className="text-lg"
              />
            )}
          {isValidDate(hotelDetails.checkInStartTime)
            && isValidDate(hotelDetails.checkOutEndTime) && (
              <div>
                {dayjs(hotelDetails.checkInStartTime).format('MMM DD')}
                {' '}
                -
                {' '}
                {dayjs(hotelDetails.checkOutEndTime).format('MMM DD')}
              </div>
          )}
        </div>
      </div>
    </>
  );
};

OverviewDetails.propTypes = {
  hotelDetails: PropTypes.shape().isRequired,
  customOverViewContent: PropTypes.string,
};
OverviewDetails.defaultProps = {
  customOverViewContent: undefined,
};

export default OverviewDetails;
